
import React from 'react';
import logo from './logo.svg';
import './App.css';
import './clean_architecture/application/components/style.css';
import '@coreui/coreui/dist/css/coreui.min.css'


import {
    BrowserRouter,
    Routes,
    Route,
    Link,
} from "react-router-dom";


// Containers
const Plantilla1 = React.lazy(() => import('./util/plantilla1'))


function App() {
    return (
        <React.Fragment>

           <BrowserRouter>
                <Routes>
                    <Route path="*" name="Home" element={<Plantilla1 />} />
                </Routes>
        </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
